import { AppShell } from './AppShell';
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ScienceIcon from '@mui/icons-material/Science';
import ForwardIcon from '@mui/icons-material/Forward';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import RuleIcon from '@mui/icons-material/Rule';
import WatchIcon from '@mui/icons-material/Watch';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import RouteIcon from '@mui/icons-material/Route';

export function PatientLayout() {
  return (
    <AppShell noChrome noSidebar
      brand={{
        title: 'MyBooking Health',
        subtitle: 'Patient portal',
        href: '/patient',
      }}
      sections={[
        {
          items: [
            { to: '/patient',                label: 'Home',          icon: <HomeIcon /> , exact: true },
            { to: '/patient/appointments',   label: 'Appointments',  icon: <EventIcon /> },
            { to: '/patient/record',         label: 'My record',     icon: <AssignmentIcon /> },
          ],
        },
        {
          heading: 'Care',
          items: [
            { to: '/patient/prescriptions',  label: 'Prescriptions', icon: <MedicalServicesIcon /> },
            { to: '/patient/sick-notes',     label: 'Sick notes',    icon: <LocalHospitalIcon /> },
            { to: '/patient/lab-orders',     label: 'Lab orders',    icon: <ScienceIcon /> },
            { to: '/patient/referrals',      label: 'Referrals',     icon: <ForwardIcon /> },
            { to: '/patient/care-pathways',  label: 'Care pathways', icon: <RouteIcon /> },
            { to: '/patient/devices',        label: 'Devices',       icon: <WatchIcon /> },
          ],
        },
        {
          heading: 'Wallet',
          items: [
            { to: '/patient/consents',          label: 'Consents',     icon: <RuleIcon /> },
            { to: '/patient/wallet',            label: 'Credentials',  icon: <VerifiedUserIcon /> },
            { to: '/patient/subscriptions',     label: 'Memberships',  icon: <SubscriptionsIcon /> },
            { to: '/patient/safety-resources',  label: 'Safety help',  icon: <HealthAndSafetyIcon /> },
          ],
        },
      ]}
    />
  );
}
